import TameeniLoader from './tameeni-loader'
import { cn } from '@/lib/utils'
import { useIsMFE } from '@/contexts/mfe-context'

const TameeniLoaderOverlay = ({
  transparent = true,
  contained,
}: {
  transparent?: boolean
  contained?: boolean
}) => {
  const isMFE = useIsMFE()
  const isContained = contained ?? isMFE

  return (
    <div
      className={cn(
        'center z-50 flex items-center justify-center',
        isContained
          ? 'absolute inset-0 min-h-[200px]'
          : 'fixed inset-0 h-screen w-screen',
        transparent ? 'bg-black/70' : 'bg-white'
      )}
    >
      <TameeniLoader />
    </div>
  )
}

export default TameeniLoaderOverlay
